import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';

export const StyledText = styled(KizenTypography)`
  text-align: center;
`;
